import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { ref } from 'vue'
import { DcMessage } from '@dc-platform/dc-components'
import CosInput from '@/components/Antd/CosInput/index.vue'
import request from '@/utils/request'

const __default__ = { name: 'AuditCouponModal' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  emits: ['success'],
  setup(__props, { expose: __expose, emit: __emit }) {

const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const selectedData = ref<any[]>([])
const formRef = ref()
const dataForm = ref<any>({})

const toggle = (data: any[]) => {
  if (!data.length) return DcMessage.error('请先选择发券申请')
  if (data.find((item: any) => item.reviewStatus !== 1)) return DcMessage.error('请选择待审核的发券申请')
  dataForm.value = {
    idList: data.map((item: any) => item.id)
  }
  selectedData.value = data
  visible.value = true
}

const emit = __emit
const handleBecomeInvalidOk = () => {
  formRef.value?.validate().then(() => {
    loading.value = true
    request
      .post('lbu/api/coupons/audit', dataForm.value)
      .then(() => {
        DcMessage.success('发券审核成功')
        visible.value = false
        emit('success')
      })
      .finally(() => {
        loading.value = false
      })
  })
}
__expose({ toggle })

return (_ctx: any,_cache: any) => {
  const _component_CosSelect = _resolveComponent("CosSelect")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_cos_modal = _resolveComponent("cos-modal")!

  return (_openBlock(), _createBlock(_component_cos_modal, {
    visible: visible.value,
    "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((visible).value = $event)),
    title: "发券申请",
    width: "670px",
    "confirm-loading": loading.value,
    onOk: handleBecomeInvalidOk
  }, {
    default: _withCtx(() => [
      (visible.value)
        ? (_openBlock(), _createBlock(_component_a_form, {
            key: 0,
            model: dataForm.value,
            ref_key: "formRef",
            ref: formRef
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_form_item, {
                name: "idList",
                label: "审核客户"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_CosSelect, {
                    value: dataForm.value.idList,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((dataForm.value.idList) = $event)),
                    options: selectedData.value,
                    fieldNames: { label: 'customerName', value: 'id' },
                    disabled: "",
                    mode: "multiple",
                    "max-tag-count": 100
                  }, null, 8, ["value", "options"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                name: "reviewStatus",
                label: "审批状态",
                rules: [{ required: true, message: '请输入' }]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_radio_group, {
                    value: dataForm.value.reviewStatus,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((dataForm.value.reviewStatus) = $event)),
                    name: "reviewStatus"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_radio, { value: "2" }, {
                        default: _withCtx(() => [
                          _createTextVNode("通过")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_radio, { value: "3" }, {
                        default: _withCtx(() => [
                          _createTextVNode("驳回")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                name: "reviewComments",
                label: "审核意见"
              }, {
                default: _withCtx(() => [
                  _createVNode(CosInput, {
                    value: dataForm.value.reviewComments,
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((dataForm.value.reviewComments) = $event)),
                    maxlength: 200
                  }, null, 8, ["value"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["visible", "confirm-loading"]))
}
}

})